















import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<VueCarouselWrapper>({
  name: 'carousel-wrapper',
  components: {},
})
export default class VueCarouselWrapper extends Vue {}
